import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPhone } from '@fortawesome/free-solid-svg-icons'
import { faInstagram, faFacebook } from '@fortawesome/free-brands-svg-icons'
import { Loader } from "@googlemaps/js-api-loader"

const axios = require('axios').default;

require('./bootstrap');

library.add(faPhone, faInstagram, faFacebook)

Vue.component('font-awesome-icon', FontAwesomeIcon)


const app = new Vue({
  el: '#app',
  mixins: [pageMixin],
  data: {
    gmapsKey: "AIzaSyA2qS9pbFkdTF9XXO20YlXEpUmt8QUPv4U",
    bgTextTips: '',
    btnDisable: true,
    minimoGranel: 150,
    terminosAceptados: false,
    etapaFormularioPedido: 1,
    mostrarMapaNuevaDireccion: false,
    direccionNueva: null,
    latLongNueva: { lat: '', long: '' },
    comunaNueva: {},
    idComunaNueva: null,
    referenciaDespacho: null,
    envio: {},
    tbkUrl: '',
    pedido: {
      telefono: '',
      tipo: 'cilindro',
      cilindro: 15,
      direccion: null,
      id_comuna: null,
      cantidad: 1,
      lat: 0,
      long: 0,
      totalPedido: 0,
      id_estado_envio: 1,
      webpay: false,
      id_despacho: null,
      despacho: {},
    },
    cliente: {
      despachos: [],
    },
    cliente2: {
      run: null,
      despachos: [],
    },
    mostrarDireccion: false,
    contanctoEnviado: false,
    enviandoContacto: false,
    contactoError: false,
    contactoErrorMessage: 'Error al enviar el mensaje',
    contacto: {
      nombreContacto: '',
      telefonoContacto: '',
      mensajeContacto: '',
    },
    enviandoEliminarUsuarioVGM: false,
    eliminarUsuarioVGM: {
      nombre: '',
      email: '',
      password: '',
    },
    run: null,
    editarUsuarios: false,
    comunas: [
      { id_comuna: 7101, nombre_comuna: 'TALCA', despacho_cilindro: true },
      { id_comuna: 7102, nombre_comuna: 'CONSTITUCIÓN', despacho_cilindro: true },
      { id_comuna: 7103, nombre_comuna: 'CUREPTO', despacho_cilindro: false },
      { id_comuna: 7104, nombre_comuna: 'EMPEDRADO', despacho_cilindro: false },
      { id_comuna: 7105, nombre_comuna: 'MAULE', despacho_cilindro: true },
      { id_comuna: 7106, nombre_comuna: 'PELARCO', despacho_cilindro: false },
      { id_comuna: 7107, nombre_comuna: 'PENCAHUE', despacho_cilindro: false },
      { id_comuna: 7108, nombre_comuna: 'RÍO CLARO', despacho_cilindro: false },
      { id_comuna: 7109, nombre_comuna: 'SAN CLEMENTE', despacho_cilindro: true },
      { id_comuna: 7110, nombre_comuna: 'SAN RAFAEL', despacho_cilindro: true },
      { id_comuna: 7201, nombre_comuna: 'CAUQUENES', despacho_cilindro: true },
      { id_comuna: 7202, nombre_comuna: 'CHANCO', despacho_cilindro: false },
      { id_comuna: 7203, nombre_comuna: 'PELLUHUE', despacho_cilindro: false },
      { id_comuna: 7301, nombre_comuna: 'CURICÓ', despacho_cilindro: false },
      { id_comuna: 7302, nombre_comuna: 'HUALAÑÉ', despacho_cilindro: false },
      { id_comuna: 7303, nombre_comuna: 'LICANTÉN', despacho_cilindro: false },
      { id_comuna: 7304, nombre_comuna: 'MOLINA', despacho_cilindro: false },
      { id_comuna: 7305, nombre_comuna: 'RAUCO', despacho_cilindro: false },
      { id_comuna: 7306, nombre_comuna: 'ROMERAL', despacho_cilindro: false },
      { id_comuna: 7307, nombre_comuna: 'SAGRADA FAMILIA', despacho_cilindro: false },
      { id_comuna: 7308, nombre_comuna: 'TENO', despacho_cilindro: false },
      { id_comuna: 7309, nombre_comuna: 'VICHUQUÉN', despacho_cilindro: false },
      { id_comuna: 7401, nombre_comuna: 'LINARES', despacho_cilindro: true },
      { id_comuna: 7402, nombre_comuna: 'COLBÚN', despacho_cilindro: true },
      { id_comuna: 7403, nombre_comuna: 'LONGAVÍ', despacho_cilindro: true },
      { id_comuna: 7404, nombre_comuna: 'PARRAL', despacho_cilindro: true },
      { id_comuna: 7405, nombre_comuna: 'RETIRO', despacho_cilindro: false },
      { id_comuna: 7406, nombre_comuna: 'SAN JAVIER', despacho_cilindro: true },
      { id_comuna: 7407, nombre_comuna: 'VILLA ALEGRE', despacho_cilindro: true },
      { id_comuna: 7408, nombre_comuna: 'YERBAS BUENAS', despacho_cilindro: true },
    ],
    comunaSelecionada: {},
    listaPrecio: {},
    convenio: {},
    googleMapsLoader: {},
    geocoder: {},
    map: null,
    mapNuevaDireccion: null,
    autocomplete: null,
    marker: {},
    descuento_granel: {},
    primeraSeccion: true,
    segundaSeccion: false,
    terceraSeccion: false,
    cuartaSeccion: false,
    ingresarDatos: true,
    enviandoReclamo: false,
    reclamo: {
      nombre_cliente: null,
      rut: null,
      telefono_cliente: null,
      email_cliente: null,
      calle: null,
      numero: null,
      depto: null,
      esquina: null,
      villa: null,
      observacion: null,
      id_motivo_reclamo: 1,
      id_comuna: null

    },
    kilosCilindro: 15
  },
  components: {

  },
  methods: {

    initGoogleMapsNuevaDireccion2: function (clickCallback) {

      this.googleMapsLoader = new Loader({
        apiKey: this.gmapsKey,
        version: "weekly",
      });

      this.googleMapsLoader.load().then(() => {

        app.geocoder = new google.maps.Geocoder();

        app.mapNuevaDireccion2 = new google.maps.Map(document.getElementById("mapNuevaDireccion2"), {
          center: { lat: -35.431625, lng: -71.637424 },
          zoom: 10,
        });
        app.mapNuevaDireccion2.addListener("click", (e) => {
          app.mapClickListener(e, app.mapNuevaDireccion2, false/**no mostrar mensaje*/, (results, status) => {
            if (status == 'OK') {

              if (clickCallback) {
                clickCallback(results);
              }
            }
          });
        });

        let myLatlng = new google.maps.LatLng(-35.431625, -71.637424);
        this.marker = new google.maps.Marker({
          position: myLatlng
        });
        this.marker.setMap(app.mapNuevaDireccion2);


      });
    },

    initGoogleMapsNuevaDireccion: function () {

      this.googleMapsLoader = new Loader({
        apiKey: this.gmapsKey,
        version: "weekly",
      });

      this.googleMapsLoader.load().then(() => {

        app.geocoder = new google.maps.Geocoder();

        app.mapNuevaDireccion = new google.maps.Map(document.getElementById("mapNuevaDireccion"), {
          center: { lat: -35.431625, lng: -71.637424 },
          zoom: 10,

        });

        app.mapNuevaDireccion.addListener("click", (e) => {
          app.mapClickListener(e, app.mapNuevaDireccion, false/**no mostrar mensaje*/, (results, status) => {
            if (status == 'OK') {
            }
          });
        });

        let myLatlng = new google.maps.LatLng(-35.431625, -71.637424);
        this.marker = new google.maps.Marker({
          position: myLatlng
        });
        this.marker.setMap(app.mapNuevaDireccion);


      });
    },

    /**
    *
    * @param {evento al hacer click en el mapa} mapsMouseEvent
    * @param {mapa donde se cambia el Pin} map
    * @param {puede ser nulo, o mostrar un mensaje de confirmación} mensaje
    * @param {función que recibe el results y status} callback
    */
    mapClickListener: function (mapsMouseEvent, map, mensaje, callback) {

      if (mensaje) {
        var res = confirm(mensaje);
        if (res) {
          app.changeMarker(mapsMouseEvent.latLng, map);
          this.geocoder.geocode({ 'location': mapsMouseEvent.latLng }, function (results, status) {
            callback(results, status);
          });
        }
      } else {
        app.changeMarker(mapsMouseEvent.latLng, map);
        this.geocoder.geocode({ 'location': mapsMouseEvent.latLng }, function (results, status) {
          callback(results, status);
        });
      }

    },
    direccionConfirmada() {
      let nuevoDespacho = {
        id: null,
        id_comuna: this.idComunaNueva,
        direccion_despacho: this.direccionNueva,
        latitude: app.latLongNueva.lat,
        longitude: app.latLongNueva.long,
        referencia: this.referenciaDespacho,
      }

      this.cliente.despachos.push(nuevoDespacho)

      this.pedido.despacho = nuevoDespacho

      this.obtenerListaPrecio();

      $('#modalMapa').modal('hide');
      this.mostrarDireccion = true;
      this.btnDisable = false;

      $('#modalPedido').modal('show');

    },
    seleccionarDespacho: async function (despacho) {

      if (this.cliente.despachos.length != 0) {
        this.pedido.despacho = despacho;
        if (this.cliente.celular_cliente == null) {
          this.pedido.telefono = this.cliente.telefono;
        }
        this.pedido.despacho.referencia = this.referenciaDespacho;
        this.pedido.telefono = this.cliente.celular_cliente;

        //TODO: asignar latLong
        let comuna = this.obtenerComunaDesdeIdComuna(this.pedido.despacho.id_comuna)
        if (this.pedido.despacho.latitude == null && this.pedido.despacho.longitude == null) {
          this.direccionToGeocoding(this.pedido.direccion + ' ' + comuna.nombre_comuna + ' CHILE', null, function (latLong) {
            app.pedido.despacho.latitude = latLong.lat
            app.pedido.despacho.longitude = latLong.long

          })
        }
      }
      this.btnDisable = false;
    },
    AgregarNuevaDireccion() {
      $('#modalPedido').modal('hide');
      $('#modalMapa').modal('show');

      document.getElementById('btnAgregarDireccion').style.display = 'none';
    },

    direccionToGeocoding: function (direccion, map = null, callback = null) {

      let latLong = { lat: "", long: "" };

      //desactivar geolocalizacion
      return latLong

      this.geocoder.geocode({ 'address': direccion }, function (results, status) {

        if (status == 'OK') {
          if (map) {
            map.setCenter(results[0].geometry.location);
            app.changeMarker(results[0].geometry.location, map);
            map.setZoom(15);
          }

          latLong = { lat: results[0].geometry.location.lat() + "", long: results[0].geometry.location.lng() + "" }
        } else {
          alert('No se encontraron resultados ');
        }

        if (callback) {
          callback(latLong)
        }
      });


    },

    changeMarker(location, map) {
      app.marker.setMap(null);
      app.marker = new google.maps.Marker({
        position: location
      });

      app.marker.setMap(map)
      map.setCenter(location);

    },//changeMarker

    cargarMapaNuevaDireccion: async function (e) {
      this.comunaNueva = { id_comuna: 7101, nombre_comuna: 'TALCA', despacho_cilindro: true };
      if (this.idComunaNueva) {
        this.comunaNueva = this.obtenerComunaDesdeIdComuna(this.idComunaNueva)
      }
      let direccion = this.direccionNueva + ' ' + this.comunaNueva.nombre_comuna + ' Chile';


      this.direccionToGeocoding(direccion, this.mapNuevaDireccion, function (latLong) {
        app.latLongNueva = latLong
      });

      // this.mostrarMapaNuevaDireccion = true;

      this.direccionConfirmada()
    },

    obtenerComunaDesdeIdComuna(idComuna) {
      return this.comunas.find((comuna) => comuna.id_comuna == idComuna);
    },


    formularioRegistro() {
      $('#modalRegistro').modal('show');
      console.log("funcionando")
    },
    validarNumero(event) {

      this.limpiarConvenio();
      this.limpiarDescuentoGranel();
      document.getElementById('btnAgregarDireccion').style.display = 'initial';
      if (event == null || event.target.checkValidity()) {
        if (this.pedido.tipo == 'tanque') {
          this.obtenerListaPrecio();

        }
        this.pedido.despacho = [];
        axios.get('/api/clientes/numero/' + this.pedido.telefono).then(
          (response) => {
            this.cliente = response.data;

            //Si solo viene un despacho, se selecciona por defecto
            if (this.cliente.despachos.length == 1) {
              this.seleccionarDespacho(this.cliente.despachos[0]);
            }

            // if(this.cliente.convenio != null && (this.cliente.id_comuna == 7401||this.cliente.id_comuna == 7402||this.cliente.id_comuna == 7408)){
            if (this.cliente.convenio != null) {
              this.convenio = response.data.convenio;
            }
            //   if(this.convenio.descuento_convenio < 2300){
            //     this.convenio.descuento_convenio = 2300;
            //   }
            // } else if(this.cliente.convenio != null && (this.cliente.id_comuna != 7401||this.cliente.id_comuna != 7402||this.cliente.id_comuna != 7408)){
            //   this.convenio = response.data.convenio;
            //   if(this.convenio.descuento_convenio < 2800){
            //     this.convenio.descuento_convenio = 2800;
            //   }
            // }


            if (this.cliente.comuna != null) {
              this.listaPrecio = response.data.comuna.lista_precio;

            }
            this.obtenerListaPrecio();

            // if (this.cliente.despachos.length == 0) {
            //   $('#modalMapa').modal('show');
            // }
            // if (this.cliente.despachos.length != 0) {
            //   $('#modalPedido').modal('show');
            // }
            $('#modalPedido').modal('show');

          }).catch(error => {
            $('#modalregister').modal('show');
          });

      }
    },
    addressKeyPress(event) {
      if (event.keyCode == 13) {
        event.preventDefault();
        return false;

      }
    },

    onComunaSeleccionada(e) {
      if (!this.pedido.despacho.id_comuna || this.pedido.tipo == 'tanque') {
        return false;
      }

      this.obtenerListaPrecio();

    },

    obtenerListaPrecio() {
      let id_caja = 60010;

      if (this.pedido.tipo != 'tanque') {
        switch (parseInt(this.pedido.despacho.id_comuna)) {
          case 7101:
            id_caja = 13
            break;
          case 7401:
            id_caja = 510
            break;
          case 7402:
            id_caja = 510
            break;
          case 7408:
            id_caja = 510
            break;

          default:
            id_caja = 13;
        }
      }

      axios.get(`/api/cajas/${id_caja}/lista_precio`).then(response => {
        this.listaPrecio = response.data;
      })
    },

    async obtenerDescuentoCliente(e) {

      this.validateRutCliente(e);
      await axios.get('/api/clientes/' + this.pedido.rut).then(async response => {
        this.convenio = response.data && response.data.convenio ? response.data.convenio : {}
        this.descuento_granel = response.data && response.data.descuento_granel ? response.data.descuento_granel : {}
      })
      this.validateRutCliente(e);
    },

    disminuirCantidadPedido() {
      if (this.pedido.cantidad <= 1) {
        return false
      }
      this.pedido.cantidad--;
    },



    getProductoFromListaPrecio(id_producto) {
      if (!this.listaPrecio.id) {
        return false;
      }

      let producto = this.listaPrecio.productos.find(producto => producto.id == id_producto);
      return producto;
    },

    getPrecioByIdProducto(id_producto) {
      let producto = this.getProductoFromListaPrecio(id_producto);

      if (!producto) {
        return 0
      }

      return producto.pivot.precio_venta;
    },

    validarCliente(event) {
      this.checkRut(document.getElementById('rutCliente'));
      if (event.target.checkValidity()) {
        this.etapaFormularioPedido = 2;
      }
    },

    finalizarPedido(event) {
      if (event.target.checkValidity()) {

        this.enviarPedido();
      }
    },

    enviarPedido() {
      this.pedido.id_comuna = this.pedido.despacho.id_comuna;
      if (this.pedido.cantidad == '') {
        alert("Ingrese una cantidad valida")
        return false;
      }
      this.btnDisable = true;
      if (this.pedido.tipo == 'cilindro') {
        this.pedido.id_cliente = this.cliente.id;
        this.pedido.cilindro = this.kilosCilindro;

        axios.post('/api/registrarPedidoWeb', this.pedido, { headers: {} }).then(response => {

          response.data.despacho = {}
          this.pedido = response.data;

          if (this.pedido.id_estado_envio == 7) {
            this.pagarTransbank();
          }
          this.etapaFormularioPedido = 3;
          console.log({ pedido: this.pedido })
        }).catch((error) => {
          console.log({ respuesta: error });
          alert("No se encuentran cajas disponibles, Comuniquese con una operadora al +569 8562 1954")
        });
      } else {
        this.pedido.id_cliente = this.cliente.id;
        axios.post('/api/enviarPedidoWebGranel', this.pedido, {
          headers: {
          }
        }).then(response => {
          this.etapaFormularioPedido = 3;
          console.log({ pedido: this.pedido })
        });
      }


    },

    pagarTransbank() {

      if (!this.pedido.rutaTbk) {
        alert('no se pudo efectuar la transacción');
      }
      console.log('pagar');
      this.tbkUrl = `${this.pedido.rutaTbk.url}?token_ws=${this.pedido.rutaTbk.token}`
      setTimeout(() => {
        $("#btnSubmitTbk").trigger("click");
      }, 500);

    },

    limpiarPedido() {
      this.pedido = {
        telefono: '',
        tipo: 'cilindro',
        id_comuna: null,
        cantidad: 1,
        webpay: false,
        despacho: {}
      }
    },
    recargarPagina() {
      location.reload();
    },

    limpiarConvenio() {
      this.convenio = {}
    },

    limpiarDescuentoGranel() {
      this.descuento_granel = {}
    },

    enviarMensajeContacto(event) {
      if (event.target.checkValidity()) {
        this.enviandoContacto = true;
        axios.post('/api/contacto', this.contacto, {
          headers: {
          }
        }).then(response => {
          this.enviandoContacto = false;
          this.contanctoEnviado = true
          this.contacto = {
            nombreContacto: '',
            telefonoContacto: '',
            mensajeContacto: '',
          }
        }).catch(error => {
          this.enviandoContacto = false;
          this.contacto = {
            nombreContacto: '',
            telefonoContacto: '',
            mensajeContacto: '',
          }
          this.contactoError = true;
        })
      }
    },

    enviarEliminarUsuarioVGM(event) {
      if (event.target.checkValidity()) {
        this.enviandoEliminarUsuarioVGM = true;
        this.contactoError = false;
        this.contanctoEnviado = false;
        axios.post('/api/eliminar-usuario-vgm', this.eliminarUsuarioVGM, {
          headers: {
          }
        }).then(response => {
          if (response.data == 'ok') {
            this.enviandoEliminarUsuarioVGM = false;
            this.contanctoEnviado = true
            this.contacto = {
              nombreContacto: '',
              telefonoContacto: '',
              mensajeContacto: '',
            }
          }

        }).catch(error => {
          if (error.response.status == 401) {
            this.contactoError = true;
            this.contactoErrorMessage = 'Usuario no autorizado';
          } else {
            this.contactoErrorMessage = 'Error al enviar el mensaje';
          }

          this.enviandoEliminarUsuarioVGM = false;
          this.contacto = {
            nombreContacto: '',
            telefonoContacto: '',
            mensajeContacto: '',
          }
          this.contactoError = true;
        })
      }
    },

    leftTrim(texto, caracter = ' ') {
      if (texto.charAt(0) == caracter) {
        texto = texto.slice(1);
        return leftTrim(texto, caracter);
      }
      return texto;
    },

    formatearRUT(rut) {
      rut = rut ? rut : '';
      let tempRut = rut.replace(/[^0-9kK]/g, '');
      tempRut = this.leftTrim(tempRut, '0');
      let arrayRUT = tempRut.split('').reverse();
      let finalRut = '';
      let indexUltimoPunto = 1;
      arrayRUT.forEach(function (caracter, index) {
        switch (index) {
          case 1:
            finalRut = caracter + '-' + finalRut
            break;
          default:
            if (indexUltimoPunto + 3 == index) {
              finalRut = caracter + '.' + finalRut;
              indexUltimoPunto = index;
            } else {
              finalRut = caracter + finalRut;
            }
            break;
        }
      });
      return finalRut;
    },

    validateRutCliente(e) {
      e.target.value = this.formatearRUT(e.target.value);
    },

    checkRut(rut) {
      // Despejar Puntos
      var valor = rut.value.replace('.', '').replace('.', '');
      // Despejar Guión
      valor = valor.replace('-', '');

      // Aislar Cuerpo y Dígito Verificador
      let cuerpo = valor.slice(0, -1);
      let dv = valor.slice(-1).toUpperCase();

      // Formatear RUN
      //rut.value = cuerpo + '-'+ dv

      // Si no cumple con el mínimo ej. (n.nnn.nnn)
      if (cuerpo.length < 7) { rut.setCustomValidity("RUT Incompleto"); return false; }

      // Calcular Dígito Verificador
      let suma = 0;
      let multiplo = 2;

      // Para cada dígito del Cuerpo
      for (let i = 1; i <= cuerpo.length; i++) {

        // Obtener su Producto con el Múltiplo Correspondiente
        let index = multiplo * valor.charAt(cuerpo.length - i);

        // Sumar al Contador General
        suma = suma + index;

        // Consolidar Múltiplo dentro del rango [2,7]
        if (multiplo < 7) { multiplo = multiplo + 1; } else { multiplo = 2; }

      }

      // Calcular Dígito Verificador en base al Módulo 11
      let dvEsperado = 11 - (suma % 11);

      // Casos Especiales (0 y K)
      dv = (dv == 'K') ? 10 : dv;
      dv = (dv == 0) ? 11 : dv;

      // Validar que el Cuerpo coincide con su Dígito Verificador
      if (dvEsperado != dv) { rut.setCustomValidity("RUT Inválido"); return false; }

      // Si todo sale bien, eliminar errores (decretar que es válido)
      rut.setCustomValidity('');
    },
    formularioReclamo1(event) {
      const mediaQuery = window.matchMedia('(min-width: 768px)')
      if (event.target.checkValidity()) {
        if (mediaQuery.matches) {
          this.primeraSeccion = true,
            this.segundaSeccion = true
        } else {
          this.primeraSeccion = false
          this.segundaSeccion = true
        }
      }
    },
    formularioReclamo2(event) {
      let formularioReclamo1 = document.getElementById('formularioReclamo1')

      if ((this.primeraSeccion && formularioReclamo1.checkValidity() || !this.primeraSeccion) && event.target.checkValidity()) {
        this.primeraSeccion = false
        this.segundaSeccion = false
        this.terceraSeccion = true
        this.ingresarDatos = false
      }
    },
    formularioReclamo3(event) {
      if (event.target.checkValidity()) {
        this.enviandoReclamo = true

        this.concatenarDireccionCliente()

        // axios.post('/api/reclamos', this.reclamo, { headers: {} }).then( response => {
        //   this.terceraSeccion = false
        //   this.cuartaSeccion = true
        //   this.enviandoReclamo = false
        // })
      }
    },
    concatenarDireccionCliente() {
      this.reclamo.direccion_cliente = this.reclamo.calle + ' ' + this.reclamo.numero

      if (this.reclamo.depto != null) {
        this.reclamo.direccion_cliente = this.reclamo.direccion_cliente + ' ' + this.reclamo.depto
      }
      if (this.reclamo.esquina != null) {
        this.reclamo.direccion_cliente = this.reclamo.direccion_cliente + ' ' + this.reclamo.esquina
      }
      if (this.reclamo.villa != null) {
        this.reclamo.direccion_cliente = this.reclamo.direccion_cliente + ' ' + this.reclamo.villa
      }
      console.log(this.reclamo.direccion_cliente)
    },

    formatearRUTReclamo: function () {
      this.reclamo.rut = this.formatearRUT(this.reclamo.rut);
      this.checkRut(document.getElementById('rut'));
    },

    triggerBtnPrimeraYSegundaSeccion: function () {

      $('#btn-reclamo1').trigger('click')
      this.primeraSeccion = true
      $('#btn-reclamo2').trigger('click')
    },
    seleccionarKilosCilindro(kilos) {
      this.kilosCilindro = kilos
      if (this.kilosCilindro == 15) {
        this.convenio = this.cliente.convenio ?? {};
        let primero = $('#15kg')
        primero.addClass('active');
        let segundo = $('#45kg')
        segundo.removeClass('active');
      } else {
        this.convenio = this.cliente.convenio45kg ?? {};
        let segundo = $('#45kg')
        segundo.addClass('active');
        let primero = $('#15kg')
        primero.removeClass('active');
      }


    }
  },//methods
  computed: {
    formAValidar: function () {
      switch (this.etapaFormularioPedido) {
        case 1:
          return 'formularioCiente';
          break;
        case 2:
          return 'formularioCilindro';
          break;

        default:
          return null
          break;
      }
    },

    comunasPedido: function () {
      if (this.pedido.tipo == 'cilindro') {
        return this.comunas.filter((comuna) => comuna.despacho_cilindro)
      } else {
        return this.comunas;
      }
    },

    netoPedido: function () {
      if (this.kilosCilindro == 15) {
        let precio15 = parseInt(this.getPrecioByIdProducto(15));
        let neto = parseInt(this.pedido.cantidad) * precio15
        return neto;
      } else if (this.kilosCilindro == 45) {
        let precio45 = parseInt(this.getPrecioByIdProducto(45));
        let neto = parseInt(this.pedido.cantidad) * precio45
        return neto;
      }

    },

    netoGranel: function () {
      let precioGranel = parseInt(this.getPrecioByIdProducto(55));
      let neto = parseInt(this.pedido.cantidad) * precioGranel
      return neto;
    },

    totalPedido: function () {
      if (this.kilosCilindro == 15) {
        let descuento = this.cliente.convenio ? this.convenio.descuento_convenio : 0;
        let precio15 = parseInt(this.getPrecioByIdProducto(15));
        let total = parseInt(this.pedido.cantidad) * (precio15 - descuento)
        this.pedido.totalPedido = total;
        return total;
      } else if (this.kilosCilindro == 45) {

        let descuento = this.cliente.convenio45kg ? this.cliente.convenio45kg.descuento_convenio : 0;
        let precio45 = parseInt(this.getPrecioByIdProducto(45));
        let total = parseInt(this.pedido.cantidad) * (precio45 - descuento)
        this.pedido.totalPedido = total;
        return total;
      }

    },

    totalDescuentoGranel: function () {
      let porcDesc = this.descuento_granel.id ? this.descuento_granel.cantidad : 0;
      return this.netoGranel * (porcDesc / 100)
    },


    totalGranel: function () {
      return parseInt(this.netoGranel - this.totalDescuentoGranel)
    },

    titleModal: function () {
      switch (this.etapaFormularioPedido) {
        case 1:
          return 'Realice su pedido';
          break;
        case 2:
          return 'Completa tu pedido';
          break;

        case 3:
          return '';
          break;

        default:
          return null
          break;
      }
    },


  },//computed
  created: function () {
    if (location.href.includes('reclamos')) {
      const mediaQuery = window.matchMedia('(min-width: 768px)')
      if (mediaQuery.matches) {
        this.primeraSeccion = true,
          this.segundaSeccion = true
      }


    }

  },
  mounted: function () {
    let numero = getParameterByName('numero');
    if (parseInt(numero) && numero.length >= 8) {
      this.pedido.telefono = numero;
      this.validarNumero();
    }
    $('body').on('hidden.bs.modal', function () {
      if ($('.modal.show').length > 0) {
        $('body').addClass('modal-open');
      }
    });

    $('#modalMapa').on('shown.bs.modal', () => {
      this.mostrarMapaNuevaDireccion = false;
      // this.initGoogleMapsNuevaDireccion();
    });

    $('#modalPedido').on('shown.bs.modal', function () {
      // app.initGoogleMapsNuevaDireccion();
    });
    $('#modalPedido').on('hide.bs.modal', function () {

      // app.limpiarPedido();
      // app.limpiarConvenio();
      // app.limpiarDescuentoGranel();
      // this.etapaFormularioPedido = 1;
    });


  }
});


(function () {
  'use strict';
  window.addEventListener('load', function () {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.getElementsByClassName('needs-validation');
    // Loop over them and prevent submission
    var validation = Array.prototype.filter.call(forms, function (form) {
      form.addEventListener('submit', function (event) {
        if (form.checkValidity() === false) {
          event.preventDefault();
          event.stopPropagation();
        }
        form.classList.add('was-validated');
      }, false);
    });
  }, false);



})();



